export default "__VITE_ASSET__CYrZSeuE__"